module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABM0lEQVRIS7XVsUuCQRjH8e9LhCBB0Jb9ARJIY6OILTUUuQkF4hJCOQiC0GJbQ9GgQSAISbRItbmoS7QF4abQ0iQiNEQEBmLGa1nZ+77evXreeHCfe+6B+z0aE1jdHZKaaldHgQOlcB/Vi1UG/0WVwf9RJbAZOjZshY4FD0NHhkXoSLAMahuWRW3BdlBpWApd24dOG4pHvZQQ/jwp1LcLwTTcZeAyIoal0OVtCOfgIQ/ZLeh+DIcN6NIGTE1D5fo3EPW9yBVUS3C2+dWK72XaCtNK9wqwuAKn61ArgdsP0QI83UNqFdqtgQQ2wJbPd8xArAwuD9wkIHAIzUc48cP7qyHWB2BhT51zEL+FBQ80anDshbdn01nxAwvR/vHZeQhfwHkIXuqWA6gHS6M25pg2CVS//xO/p2YvVvim1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/ic_product_spec_selected.png
// module id = VJH3
// module chunks = 1